import axios from 'axios'

var qs = require('qs');
var root = process.env.API_ROOT


//获取列表数据
export const getListData = (params) => {
  return axios.post(root + '/set/jxcstore/list', qs.stringify(params))
}

//获取明细
export const getDetail = (params) => {
  return axios.post(root + '/set/jxcstorelimit/edit', qs.stringify(params))
}

//获取不需要过滤独立核算部门
export const getListDataall = (params) => {
  return axios.post(root + '/set/jxcstore/listall', qs.stringify(params))
}

//获取需要过滤独立核算部门
export const getListDatabyinpd = (params) => {
  return axios.post(root + '/set/jxcstore/listbyipd', qs.stringify(params))
}

//删除行
export const deleteData = (params) => {
  return axios.post(root + '/set/jxcstore/remove', qs.stringify(params))
}

//保存某一行的数据
export const saveData = (params) => {

  return axios.post(root + '/set/jxcstorelimit/save', qs.stringify(params))
}
//保存某一行的数据
export const clearData = (params) => {
  return axios.post(root + '/set/jxcstorelimit/clear', qs.stringify(params))
}



// WEBPACK FOOTER //
// ./src/api/set/jxcstorelimit.js